<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        로고 설정
                        <div class="clear"></div>
                    </div>
                    <site-setting-component></site-setting-component>
                    <div class="text_center mt15">
                        <el-button type="primary" @click="submitForm('ruleForm')">저장</el-button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import SiteSettingComponent from "@/components/site/SiteSettingComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: 'Site',
    mixins: [],
    components: {SiteSettingComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            EventBus.$emit('runSetting');
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
